/**
 * Owner: Masa Bayu
 * File: advanced-adam.ts
 * Date:Time: 2026-09-16 18:50
 * Description: T8-E7 AdamEntryContext gates — Integrates ADAM; ≠ Own intelligence.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { assertT8E7SecurityIntact } from './advanced-security';
import { isEntitlementActiveForRead } from './entitlement-boundary';
import { createQxreadId } from './id';
import { assertTimestamp, assertValidId } from './guards';
export const QXREAD_ADAM_CAPABILITY_GATES = ['available', 'partial', 'blocked'];
function assertGate(value, label) {
    if (typeof value !== 'string' ||
        !QXREAD_ADAM_CAPABILITY_GATES.includes(value)) {
        throw new Error(`${label} must be one of: ${QXREAD_ADAM_CAPABILITY_GATES.join(', ')}`);
    }
    return value;
}
export function evaluateAdamEntryContext(input) {
    assertNoForbiddenFoundationKey(input, 'QXRead ADAM entry');
    assertT8E7SecurityIntact();
    assertValidId(input.accountId, 'QXRead ADAM accountId');
    assertValidId(input.publicationId, 'QXRead ADAM publicationId');
    const createdAt = input.createdAt ?? new Date().toISOString();
    assertTimestamp(createdAt, 'QXRead ADAM createdAt');
    const adamEntryId = input.adamEntryId !== undefined ? input.adamEntryId : createQxreadId('qxrdadam');
    assertValidId(adamEntryId, 'QXRead adamEntryId');
    let gate = 'available';
    let reason = 'Entitlement and Reader context present — ADAM entry gated available';
    if (!isEntitlementActiveForRead(input.entitlement)) {
        gate = 'blocked';
        reason = 'ADAM entry blocked without active entitlement';
    }
    else if (input.entitlement.accountId !== input.accountId) {
        gate = 'blocked';
        reason = 'ADAM entry blocked — entitlement account mismatch';
    }
    else if (input.entitlement.publicationId !== input.publicationId) {
        gate = 'blocked';
        reason = 'ADAM entry blocked — entitlement publication mismatch';
    }
    else if (input.readerSessionRef === null || input.readerSessionRef.trim().length === 0) {
        gate = 'partial';
        reason = 'ADAM entry partial — Reader session context missing';
    }
    return Object.freeze({
        adamEntryId,
        accountId: input.accountId,
        publicationId: input.publicationId,
        readerSessionRef: input.readerSessionRef,
        gate: assertGate(gate, 'QXRead ADAM gate'),
        reason,
        createdAt,
        ownsAdamIntelligence: false,
        mutatesPublication: false,
        inventsEntitlement: false,
    });
}
//# sourceMappingURL=advanced-adam.js.map